<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { Manifest } from '../data/types';
  import { ROUTES, type AppState, type RouteId } from '../state/app.svelte';
  import Icon from '../ui/Icon.svelte';

  let { state, manifest, children }: { state: AppState; manifest: Manifest; children: Snippet } =
    $props();

  const mobileRoutes: ReadonlyArray<{ id: RouteId | 'flows'; label: string; icon: string }> = [
    { id: 'home', label: 'Home', icon: 'home' },
    { id: 'net-worth', label: 'Patrimonio', icon: 'trend' },
    { id: 'accounts', label: 'Account', icon: 'wallet' },
    { id: 'flows', label: 'Flussi', icon: 'arrow-down' },
    { id: 'transactions', label: 'Movimenti', icon: 'list' },
  ];

  function navigate(event: MouseEvent, id: RouteId): void {
    event.preventDefault();
    state.navigate(id);
  }

  function navigateMobile(event: MouseEvent, id: RouteId | 'flows'): void {
    navigate(event, id === 'flows' ? (state.route === 'income' ? 'income' : 'expenses') : id);
  }
</script>

<a class="skip-link" href="#main-content">Vai al contenuto</a>
<div class="app-shell">
  <aside class="desktop-rail" aria-label="Navigazione principale">
    <a
      href="/"
      class="brand"
      onclick={(event) => navigate(event, 'home')}
      aria-label="Simeone Money, Home"
    >
      <span class="brand-mark">S</span><span class="brand-copy"><small>Simeone</small>Money</span>
    </a>
    <nav>
      {#each ROUTES as route}
        <a
          href={state.toUrl(route.id)}
          class:active={state.route === route.id}
          aria-current={state.route === route.id ? 'page' : undefined}
          aria-label={route.label}
          onclick={(event) => navigate(event, route.id)}
          ><Icon name={route.icon} /><span>{route.label}</span></a
        >
      {/each}
    </nav>
    <div class="rail-footer">
      <p>Aggiornato</p>
      <strong
        >{new Intl.DateTimeFormat('it-IT', { day: '2-digit', month: 'short' }).format(
          new Date(manifest.generated_at),
        )}</strong
      >
    </div>
  </aside>

  <div class="app-content">
    <header class="mobile-topbar">
      <a
        href="/"
        class="brand"
        aria-label="Simeone Money, Home"
        onclick={(event) => navigate(event, 'home')}
        ><span class="brand-mark">S</span><span class="brand-copy"><small>Simeone</small>Money</span
        ></a
      >
      <button
        class="icon-button"
        type="button"
        aria-label={state.dark ? 'Usa tema chiaro' : 'Usa tema scuro'}
        onclick={() => state.toggleTheme()}
      >
        <Icon name={state.dark ? 'sun' : 'moon'} />
      </button>
    </header>
    {@render children()}
  </div>

  <nav class="mobile-bottom-nav" aria-label="Navigazione principale mobile">
    {#each mobileRoutes as route}
      {@const active =
        route.id === 'flows'
          ? state.route === 'expenses' || state.route === 'income'
          : state.route === route.id}
      <a
        href={state.toUrl(route.id === 'flows' ? 'expenses' : route.id)}
        class:active
        aria-current={active ? 'page' : undefined}
        aria-label={route.label}
        onclick={(event) => navigateMobile(event, route.id)}
        ><Icon name={route.icon} size={19} /><span>{route.label}</span></a
      >
    {/each}
  </nav>
</div>
